<div class="mt-2 mb-2">
    <mat-accordion>
        <mat-expansion-panel [expanded]="panelOpenState()" (opened)="panelOpenState.set(true)" (closed)="panelOpenState.set(false)">
            <mat-expansion-panel-header>
                <mat-panel-title><span class="title">Dati Analitici</span></mat-panel-title>
                <mat-panel-description class="justify-content-end">
                    @if (!saved) {
<i class="bi bi-exclamation-circle-fill" style="color: red; font-size: large;"></i>
}
                    @if (saved) {
<i class="bi bi-check-circle-fill" style="color: green; font-size: large;"></i>
}
                </mat-panel-description>
            </mat-expansion-panel-header>

            <div class="container-fluid p-1 p-lg-2">
                <form [formGroup]="analyticalForm">
                    <div class="row justify-content-start pb-2 mt-2">
                        <div class="col-12 mt-2 text-center">
                            <span class="subTitle">Descrizione</span>
                        </div>

                        <!-- Campo objectIndications -->
                        <div class="col-12">
                            <label for="objectIndications" class="form-label mt-3"
                                style="font-weight: bold;">Indicazioni sull'oggetto</label>
                            <div class="input-group">
                                <textarea type="text" class="form-control" id="objectIndications"
                                    formControlName="objectIndications"
                                    [class.is-invalid]="analyticalForm.get('objectIndications')?.invalid && (analyticalForm.get('objectIndications')?.dirty || submitted)">
                                </textarea>
                            </div>
                            @if (analyticalForm.get('objectIndications')?.invalid && analyticalForm.get('objectIndications')?.dirty) {
<div
                               >
                                <span style="font-size: x-small; color: red;">Max 1300 caratteri</span>
                            </div>
}
                        </div>

                        <!-- Campo subjectIndication -->
                        <div formArrayName="subjectIndication">
                            @for (item of subjectIndications.controls; track item; let i = $index) {
<div [formGroupName]="i"
                                class="col-12">
                                <label for="subjectIndication-{{i}}" class="form-label mt-3"
                                    style="font-weight: bold;">Indicazioni sul soggetto</label>
                                <div class="input-group">
                                    <textarea type="text" class="form-control" id="subjectIndication-{{i}}"
                                        formControlName="subjectIndication"
                                        [class.is-invalid]="item.get('subjectIndication')?.invalid && (item.get('subjectIndication')?.dirty || submitted)">
                                    </textarea>
                                    @if (i != 0) {
<button class="btn btn-sm btn-danger"
                                        (click)="removeSubjectIndications(i)">
                                        <i class="bi bi-trash"></i>
                                    </button>
}
                                </div>
                                @if (item.get('subjectIndication')?.invalid && item.get('subjectIndication')?.dirty) {
<div
                                   >
                                    <span style="font-size: x-small; color: red;">Max 2000 caratteri</span>
                                </div>
}
                            </div>
}
                        </div>
                        <!-- Aggiungi nuovo gruppo di campi -->
                        <div class="col-12 mt-1 text-start">
                            <button class="btn btn-outline-dark" (click)="addSubjectIndications()">
                                <span class="me-2">Aggiungi Indicazioni Soggetto</span>
                                <i class="bi bi-plus"></i>
                            </button>
                        </div>
                    </div>

                    <div formArrayName="subscriptions">
                        @for (chronology of subscriptions.controls; track chronology; let i = $index) {
<div [formGroupName]="i"
                            style="border: 1px solid lightgray; border-radius: 10px; position: relative;"
                            class="row justify-content-start pb-2 mt-2">

                            @if (i != 0) {
<div class="col-12 removeButton">
                                <!-- Rimuovi -->
                                @if (i != 0) {
<button class="btn btn-sm btn-danger me-2 mt-2"
                                    (click)="removeSubscriptions(i)" [disabled]="subscriptions.length === 1">
                                    <i class="bi bi-trash"></i>
                                </button>
}
                                <label class="d-none d-md-inline" style="font-weight: bold;">Iscrizioni {{i + 1}}</label><br>
                            </div>
}
                            <div class="col-12 mt-2 text-center" style="padding-left: 0;">
                                <span class="subTitle">Iscrizioni</span>
                            </div>

                            <!-- Campo Classe di appartenenza -->
                            <div class="col-12 col-md-6 col-lg-4">
                                <label for="membershipClass1-{{i}}" class="form-label mt-3"
                                    style="font-weight: bold;">Classe di appartenenza</label>
                                <select class="form-select" aria-label="Default select example"
                                    formControlName="membershipClass" id="membershipClass1-{{i}}">
                                    <option [ngValue]="null">Non specificato</option>
                                    @for (option of listAnalyicalData?.membershipClassSub; track option) {
<option [ngValue]="option.id"
                                        class="form-control">
                                        {{option.definition}}
                                    </option>
}
                                </select>
                            </div>

                            <!-- Campo Lingua -->
                            <div class="col-12 col-md-6 col-lg-4">
                                <label for="language-{{i}}" class="form-label mt-3"
                                    style="font-weight: bold;">Lingua</label>
                                <select class="form-select" aria-label="Default select example"
                                    formControlName="language" id="language-{{i}}">
                                    <option [ngValue]="null">Non specificato</option>
                                    @for (option of listAnalyicalData?.language; track option) {
<option [ngValue]="option.id" class="form-control">
                                        {{option.definition}}
                                    </option>
}
                                </select>
                            </div>

                            <!-- Campo Technique -->
                            <div class="col-12 col-md-6 col-lg-4">
                                <label for="technique-{{i}}" class="form-label mt-3" style="font-weight: bold;">Tecnica
                                    di scrittura</label>
                                <select class="form-select" aria-label="Default select example"
                                    formControlName="technique" id="technique-{{i}}">
                                    <option [ngValue]="null">Non specificato</option>
                                    @for (option of listAnalyicalData?.technique; track option) {
<option [ngValue]="option.id" class="form-control">
                                        {{option.definition}}
                                    </option>
}
                                </select>
                            </div>

                            <!-- Campo charactersType -->
                            <div class="col-12 col-md-6 col-lg-4">
                                <label for="charactersType-{{i}}" class="form-label mt-3"
                                    style="font-weight: bold;">Tipo di caratteri</label>
                                <select class="form-select" aria-label="Default select example"
                                    formControlName="charactersType" id="charactersType-{{i}}">
                                    <option [ngValue]="null">Non specificato</option>
                                    @for (option of listAnalyicalData?.charactersType; track option) {
<option [ngValue]="option.id"
                                        class="form-control">
                                        {{option.definition}}
                                    </option>
}
                                </select>
                            </div>

                            <!-- Campo Author -->
                            <div class="col-12 col-md-6 col-lg-4">
                                <label for="author-{{i}}" class="form-label mt-3"
                                    style="font-weight: bold;">Autore</label>
                                <div class="input-group">
                                    <input type="text" class="form-control" id="author-{{i}}" formControlName="author"
                                        [class.is-invalid]="subscriptions.at(i).get('author')?.invalid && (subscriptions.at(i).get('author')?.dirty || submitted)">
                                </div>
                                @if (subscriptions.at(i).get('author')?.invalid && subscriptions.at(i).get('author')?.dirty) {
<div
                                   >
                                    <span style="font-size: x-small; color: red;">Max 100 caratteri</span>
                                </div>
}
                            </div>

                            <!-- Campo location -->
                            <div class="col-12 col-md-6 col-lg-4">
                                <label for="location1-{{i}}" class="form-label mt-3"
                                    style="font-weight: bold;">Posizione</label>
                                <div class="input-group">
                                    <input type="text" class="form-control" id="location1-{{i}}"
                                        formControlName="location"
                                        [class.is-invalid]="subscriptions.at(i).get('location')?.invalid && (subscriptions.at(i).get('location')?.dirty || submitted)">
                                </div>
                                @if (subscriptions.at(i).get('location')?.invalid && subscriptions.at(i).get('location')?.dirty) {
<div
                                   >
                                    <span style="font-size: x-small; color: red;">Max 100 caratteri</span>
                                </div>
}
                            </div>

                            <!-- Campo transcription -->
                            <div class="col-12">
                                <label for="transcription-{{i}}" class="form-label mt-3"
                                    style="font-weight: bold;">Trascrizione</label>
                                <div class="input-group">
                                    <textarea type="text" class="form-control" id="transcription-{{i}}"
                                        formControlName="transcription"
                                        [class.is-invalid]="subscriptions.at(i).get('transcription')?.invalid && (subscriptions.at(i).get('transcription')?.dirty || submitted)">
                                        </textarea>
                                </div>
                                @if (subscriptions.at(i).get('transcription')?.invalid && subscriptions.at(i).get('transcription')?.dirty) {
<div
                                   >
                                    <span style="font-size: x-small; color: red;">Max 10000 caratteri</span>
                                </div>
}
                            </div>
                        </div>
}
                    </div>

                    <!-- Aggiungi nuovo gruppo di campi -->
                    <div class="col-12 mt-1 mb-3 text-center">
                        <button class="btn btn-outline-dark" (click)="addSubscriptions()">
                            <span class="me-2">Aggiungi Iscrizioni</span>
                            <i class="bi bi-plus"></i>
                        </button>
                    </div>

                    <!-- FormArray per Stemmi ed Emblemi -->
                    <div formArrayName="emblems">
                        @for (chronology of emblems.controls; track chronology; let i = $index) {
<div [formGroupName]="i"
                            style="border: 1px solid lightgray; border-radius: 10px; position: relative;"
                            class="row justify-content-start pb-2 mt-2">

                            @if (i != 0) {
<div class="col-12 removeButton">
                                <!-- Rimuovi -->
                                @if (i != 0) {
<button class="btn btn-sm btn-danger me-2 mt-2"
                                    (click)="removeEmblems(i)">
                                    <i class="bi bi-trash"></i>
                                </button>
}
                                <label class="d-none d-lg-inline" style="font-weight: bold;">Stemmi, Emblemi, Marchi {{i + 1}}</label><br>
                            </div>
}
                            <div class="col-12 mt-2 text-center" style="padding-left: 0;">
                                <span class="subTitle">Stemmi, Emblemi, Marchi</span>
                            </div>

                            <!-- Campo Classe di appartenenza -->
                            <div class="col-12 col-md-6 col-lg-4">
                                <label for="membershipClass2-{{i}}" class="form-label mt-3"
                                    style="font-weight: bold;">Classe di appartenenza</label>
                                <select class="form-select" aria-label="Default select example"
                                    formControlName="membershipClass" id="membershipClass2-{{i}}">
                                    <option [ngValue]="null">Non specificato</option>
                                    @for (option of listAnalyicalData?.membershipClassArm; track option) {
<option [ngValue]="option.id"
                                        class="form-control">
                                        {{option.definition}}
                                    </option>
}
                                </select>
                            </div>

                            <!-- Campo Qualificazione -->
                            <div class="col-12 col-md-6 col-lg-4">
                                <label for="qualification-{{i}}" class="form-label mt-3"
                                    style="font-weight: bold;">Qualificazione</label>
                                <select class="form-select" aria-label="Default select example"
                                    formControlName="qualification" id="qualification-{{i}}">
                                    <option [ngValue]="null">Non specificato</option>
                                    @for (option of listAnalyicalData?.qualification; track option) {
<option [ngValue]="option.id"
                                        class="form-control">
                                        {{option.definition}}
                                    </option>
}
                                </select>
                            </div>

                            <!-- Campo Identification -->
                            <div class="col-12 col-md-6 col-lg-4">
                                <label for="identification-{{i}}" class="form-label mt-3"
                                    style="font-weight: bold;">Identificazione</label>
                                <div class="input-group">
                                    <input type="text" class="form-control" id="identification-{{i}}"
                                        formControlName="identification"
                                        [class.is-invalid]="emblems.at(i).get('identification')?.invalid && (emblems.at(i).get('identification')?.dirty || submitted)">
                                </div>
                                @if (emblems.at(i).get('identification')?.invalid && emblems.at(i).get('identification')?.dirty) {
<div
                                   >
                                    <span style="font-size: x-small; color: red;">Max 100 caratteri</span>
                                </div>
}
                            </div>

                            <!-- Campo Quantity -->
                            <div class="col-12 col-md-6 col-lg-4">
                                <label for="quantity-{{i}}" class="form-label mt-3"
                                    style="font-weight: bold;">Quantità</label>
                                <div class="input-group">
                                    <input type="text" class="form-control" id="quantity-{{i}}"
                                        formControlName="quantity"
                                        [class.is-invalid]="emblems.at(i).get('quantity')?.invalid && (emblems.at(i).get('quantity')?.dirty || submitted)">
                                </div>
                                @if (emblems.at(i).get('quantity')?.invalid && emblems.at(i).get('quantity')?.dirty) {
<div
                                   >
                                    <span style="font-size: x-small; color: red;">Max 10 caratteri</span>
                                </div>
}
                            </div>

                            <!-- Campo Location -->
                            <div class="col-12 col-md-6 col-lg-4">
                                <label for="location2-{{i}}" class="form-label mt-3"
                                    style="font-weight: bold;">Posizione</label>
                                <div class="input-group">
                                    <input type="text" class="form-control" id="location2-{{i}}"
                                        formControlName="location"
                                        [class.is-invalid]="emblems.at(i).get('location')?.invalid && (emblems.at(i).get('location')?.dirty || submitted)">
                                </div>
                                @if (emblems.at(i).get('location')?.invalid && emblems.at(i).get('location')?.dirty) {
<div
                                   >
                                    <span style="font-size: x-small; color: red;">Max 100 caratteri</span>
                                </div>
}
                            </div>

                            <!-- Campo Description -->
                            <div class="col-12">
                                <label for="description-{{i}}" class="form-label mt-3"
                                    style="font-weight: bold;">Descrizione</label>
                                <div class="input-group">
                                    <textarea type="text" class="form-control" id="description-{{i}}"
                                        formControlName="description"
                                        [class.is-invalid]="emblems.at(i).get('description')?.invalid && (emblems.at(i).get('description')?.dirty || submitted)">
                                        </textarea>
                                </div>
                                @if (emblems.at(i).get('description')?.invalid && emblems.at(i).get('description')?.dirty) {
<div
                                   >
                                    <span style="font-size: x-small; color: red;">Max 500 caratteri</span>
                                </div>
}
                            </div>
                        </div>
}
                    </div>

                    <!-- Aggiungi nuovo gruppo di campi -->
                    <div class="col-12 mt-1 text-center">
                        <button class="btn btn-outline-dark" (click)="addEmblems()">
                            <span class="me-2">Aggiungi Stemmi, Emblemi, Marchi</span>
                            <i class="bi bi-plus"></i>
                        </button>
                    </div>

                    <!-- Campo HistoricalNews -->
                    <div class="col-12 pb-2 mt-2">
                        <label for="historycalNews" class="form-label mt-3" style="font-weight: bold;">Notizie
                            Storico-Critiche</label>
                        <div class="input-group">
                            <textarea type="text" class="form-control" id="historycalNews"
                                formControlName="historycalNews"
                                [class.is-invalid]="analyticalForm.get('historycalNews')?.invalid && (analyticalForm.get('historycalNews')?.dirty || submitted)">
                                </textarea>
                        </div>
                        @if (analyticalForm.get('historycalNews')?.invalid && analyticalForm.get('historycalNews')?.dirty) {
<div
                           >
                            <span style="font-size: x-small; color: red;">Max 5000 caratteri</span>
                        </div>
}
                    </div>
                </form>

                <!-- Pulsante di Salvataggio -->
                <div class="row justify-content-center mt-4 borderTop">
                    @if (analyticalForm.invalid && submitted) {
<div class="col-12 mt-2 text-center">
                        <small>Compilare correttamente tutti i campi obbligatori per abilitare il
                            salvataggio
                        </small>
                    </div>
}
                    <div class="col-12 col-md-6 col-lg-4 mt-1 text-center">
                        <button class="btn btn-outline-dark"
                            (click)="save()">Salva</button>
                    </div>
                </div>
            </div>
        </mat-expansion-panel>
    </mat-accordion>
</div>
